import React from "react";
import KC_UIText from "../../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../../../designsystem/ds_commons";
import KC_CustomSelect, {
  KC_CustomSelectChild
} from "../../../../../../designsystem/KC_CustomSelect/KC_CustomSelect";
import KC_Checkbox from "../../../../../../designsystem/KC_FormInput/KC_Checkbox";
import { CLIENTS_PER_DAY_ANSWER } from "../../../../../../utils/constants";

interface Props {
  id: string;
  label: string;
  selected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}

export default function ChooseClientPerDay(props: Props) {
  const getSelectedLabel = () => {
    const match = CLIENTS_PER_DAY_ANSWER.find((a) => a.name === props.selected);
    return match?.displayName || "";
  };

  const handleCheck = (name: string) => {
    props.setSelected(props.selected === name ? "" : name);
  };

  return (
    <div className="mb-5">
      <label className="mb-3">
        <KC_UIText weight={KC_Weights.md} text={props.label} />
      </label>
      <KC_CustomSelect
        id={props.id}
        className="dropdown"
        placeholder={getSelectedLabel()}
      >
        {CLIENTS_PER_DAY_ANSWER.map((answer) => {
          const isChecked = props.selected === answer.name;

          return (
            <KC_CustomSelectChild
              key={answer.name}
              onClick={(e) => {
                e?.stopPropagation?.();
                handleCheck(answer.name);
              }}
            >
              <div
                id={`${props.id}-option-${answer.name}`}
                className="d-flex w-100 gap-sm"
              >
                <KC_Checkbox checked={isChecked} />
                <KC_UIText
                  weight="reg"
                  className="d-inline-block w-100 white-space-normal"
                  text={answer.displayName}
                />
              </div>
            </KC_CustomSelectChild>
          );
        })}
      </KC_CustomSelect>
    </div>
  );
}
